window.mathLatexParser = require('../lib/index.js');
